import Vue from 'vue'
import Router from 'vue-router'
import store from "../q-components/q-store";
import authorization from '../q-components/q-user'


//Site
import home from '../views/home/home'
import homeIndex from '../views/home/index'

import login from '../views/member/login.vue'

//import userProfile from '../views/member/userProfile'
import register from '../views/member/register'
import resetPassword from '../views/member/resetPassword.vue'
import lockSession from '../views/member/lockSession.vue'

//BLOG
import blog from '../views/home/blog/blog'
import blogIndex from '../views/home/blog/index'
import blogSearch from '../views/home/blog/search'
import post from '../views/home/blog/post'

//PAGES
import contact from '../views/home/contact'
import document from '../views/home/document/document'

//Dashboard
import dashboard from '../views/dashboard/dashboard.vue'
import dashboardIndex from '../views/dashboard/index'

import form from '../views/dashboard/form'

import postList from "../views/dashboard/blog/postList";
import editPost from "../views/dashboard/blog/editPost";
import newPost from "../views/dashboard/blog/newPost";

import list from '../views/dashboard/models/list'
import detail from '../views/dashboard/models/detail.vue'

import messageList from '../views/dashboard/inbox/message/messageList'
import message from '../views/dashboard/inbox/message/message.vue'
import taskList from '../views/dashboard/inbox/task/taskList.vue'
import task from '../views/dashboard/inbox/task/task.vue'

import bpmn from '../views/dashboard/bpmn/bpmn'

import page from '../views/page/page.vue'

function requireAuth(to, from, next) {
  const loggedIn = authorization.loggedIn();
  const grantTo = authorization.authorize(to);

  if (!loggedIn || !grantTo) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    if (store.state.session.locked) {
      next({
        path: '/lock',
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  }
}

Vue.use(Router);

export default new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/resetPassword',
      name: 'resetPassword',
      component: resetPassword,
    },

    {
      path: '/',
      component: home,
      children: [
        {
          name: 'home',
          path: '/',
          component: homeIndex,
          props: true
        },
        {
          path: '/contact',
          name: 'contact',
          component: contact,
          props: true,
        },
        {
          path: '/document',
          name: 'document',
          component: document,
          props: true,
        },
        {
          path: '/page/:id',
          name: 'page',
          component: page,
          props: true,
        },
        {
          path: '/blog',
          component: blog,
          children: [
            {
              name: 'posts',
              path: 'posts/:category',
              component: blogIndex,
              props: true
            },
            {
              name: 'search',
              path: 'search/:word',
              component: blogSearch,
              props: true
            },
            {
              name: 'post',
              path: 'post/:id',
              component: post,
              props: true
            }
          ]
        },
      ]
    },
    {
      path: '/dashboard',
      component: dashboard,
      beforeEnter: requireAuth,
      children: [
        {
          name: 'dashboard',
          path: '/',
          component: dashboardIndex,
          props: true
        },
        {
          path: '/logout',
          name: 'logout',
          beforeEnter(to, from, next) {
            authorization.logout(store.state.session.sessionId, next);
          }
        },
        {
          path: '/lock',
          name: 'lock',
          component: lockSession,
        },
        {
          path: 'postList',
          name: 'postList',
          component: postList,
          props: true
        },
        {
          path: 'editPost/:postId',
          name: 'editPost',
          component: editPost,
          props: true
        },
        {
          path: 'newPost',
          name: 'newPost',
          component: newPost,
          props: true
        },
        {
          path: 'form/:structureKey',
          name: 'form',
          component: form,
          props: true,
        },
        {
          path: 'detail/:structureKey/:modelId',
          name: 'detail',
          component: detail,
          props: true
        },
        {
          path: 'list/:structureKey',
          name: 'list',
          component: list,
          props: true
        },
        {
          path: 'bpmn/:processId',
          name: 'bpmn',
          component: bpmn,
          props: true,
        },
        {
          path: 'messages',
          name: 'messages',
          component: messageList,
          props: true
        },
        {
          path: 'message/:messageId',
          name: 'message',
          component: message,
          props: true
        },
        {
          path: 'tasks/:taskKey',
          name: 'tasks',
          component: taskList,
          props: true
        },
        {
          path: '/task/:taskKey/:instanceId/:activityInstanceId',
          name: 'task',
          component: task,
          props: true
        }
      ]
    },
  ]
})
